import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "d-block" }
const _hoisted_2 = {
  key: 0,
  class: "btn-group-vertical",
  role: "group",
  style: {"width":"100%"}
}
const _hoisted_3 = ["id", "value"]
const _hoisted_4 = ["for", "onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-center justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border mt-3",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "position-relative"
}
const _hoisted_9 = { class: "mb-1 fs-16" }
const _hoisted_10 = { class: "mt-3 text-bg-light p-3 fs-md-13 fs-lg-14" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-copy" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_17 = { class: "form-check mt-3" }
const _hoisted_18 = {
  class: "form-check-label",
  for: "alwaysOpenInClient"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isOpen) = $event)),
    centered: "",
    title: !_ctx.streamedData && !_ctx.isDrafting ? 'Reason for Passing' : (_ctx.isDrafting && !_ctx.streamedData ? 'Writing draft...' : 'Your draft'),
    "hide-footer": "",
    "dialog-class": _ctx.streamedData ? 'modal-md' : 'modal-sm',
    onHide: _ctx.close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.streamedData && !_ctx.isDrafting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passReasons, (reason) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: reason.id
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "btn-check",
                    name: "btnradio",
                    id: reason.id,
                    autocomplete: "off",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedID) = $event)),
                    value: reason.id
                  }, null, 8, _hoisted_3), [
                    [_vModelRadio, _ctx.selectedID]
                  ]),
                  _createElementVNode("label", {
                    class: "btn btn-outline-primary",
                    for: reason.id,
                    onClick: ($event: any) => (_ctx.selectedID = reason.id)
                  }, _toDisplayString(reason.label), 9, _hoisted_4)
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDrafting && !_ctx.streamedData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.streamedData && _ctx.isDrafting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("h6", _hoisted_9, "Customized follow-up" + _toDisplayString(_ctx.companyName ? ` for ${_ctx.companyName}` : '') + ":", 1),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.streamedData) = $event)),
                readonly: "",
                style: {"display":"none"}
              }, null, 512), [
                [_vModelText, _ctx.streamedData]
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.recipientName ? `Hi ${_ctx.recipientName},` : 'Hi,'), 1),
                _hoisted_11,
                _hoisted_12,
                _createElementVNode("div", {
                  innerHTML: _ctx.streamedData.replace(/\n/g, '<br>')
                }, null, 8, _hoisted_13)
              ]),
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args))),
                class: "btn btn-sm btn-secondary position-absolute bottom-0 end-0 mb-1 me-1"
              }, _hoisted_15)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_16, [
        (!_ctx.streamedData && !_ctx.isDrafting)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.isActionsEnabled)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_b_button, {
                      class: "mt-3 btn btn-secondary btn-sm",
                      onClick: _ctx.save
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Save")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_b_button, {
                      class: "mt-3 btn btn-primary btn-sm",
                      onClick: _ctx.saveDraft
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Save & Draft Email")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (_openBlock(), _createBlock(_component_b_button, {
                    key: 1,
                    class: "mt-3 btn btn-primary btn-sm w-100",
                    onClick: _ctx.saveDraft
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Draft Pass Email")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.streamedData)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.alwaysOpenInClient) = $event)),
                  id: "alwaysOpenInClient"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.alwaysOpenInClient]
                ]),
                _createElementVNode("label", _hoisted_18, " Auto Open " + _toDisplayString(_ctx.loginType === 'gsuite' ? 'Gmail' : 'Email App'), 1)
              ]),
              _createVNode(_component_b_button, {
                class: "mt-3 btn btn-primary btn-sm",
                onClick: _ctx.openEmail
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Open in " + _toDisplayString(_ctx.loginType === 'gsuite' ? 'Gmail' : 'Email App'), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "dialog-class", "onHide"]))
}